module.exports = __webpack_public_path__ + "img/strat_bnb_stable.f3668703.png";